import script from "./VacinaLista.vue?vue&type=script&setup=true&lang=js"
export * from "./VacinaLista.vue?vue&type=script&setup=true&lang=js"

import "./VacinaLista.vue?vue&type=style&index=0&id=65526e8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65526e8d"]])

export default __exports__